import { Component } from '@angular/core';
import { DocumentTypeCode, DocumentUploadSource, TEMP_DOCUMENTS_UPLOAD_URL } from '@app/shared/document/document-data.service';
import { IUploadFormData } from '@app/shared/multi-file-upload/multi-file-upload.component';

@Component({
  selector: 'multi-file-upload-demo',
  template: `
    <div>
      <multi-file-upload
        [path]="postUrl"
        (onQueueChange)="onFileChange($event)"
        [uploading]="uploading"
        (onUploadCompleted)="onUploadCompleted($event)"
        (onUploadCancelled)="onUploadCancelled()"
        (onUploadError)="onUploadError()"
        [filesAccepted]="['image/*', 'video/*']"
        [showButtons]="true"
        [uploadFormData]="uploadFormData">
      </multi-file-upload>
    </div>
  `
})
export class MultiFileUploadDemoComponent {
  public postUrl:string = TEMP_DOCUMENTS_UPLOAD_URL;
  public uploading:boolean;
  public cancelling:boolean;
  public uploadFormData:IUploadFormData = {
    documentTypeCode: DocumentTypeCode.PICTURE,
    documentUploadSource: DocumentUploadSource.TINYMCE_EDITOR
  };

  public onFileChange(data) {
    console.log('onFileChange', data);
  }

  public onUploadCompleted(data) {
    console.log('onUploadCompleted', data);
  }

  public onUploadCancelled() {
    console.log('onUploadCancelled');
  }

  public onUploadError():void {
    console.log('onUploadError');
  }
}